import React, { useCallback, useEffect, useState } from 'react'
import PhotoViewer from '../ui/PhotoViewer'

export const OPEN_EVENT = 'photo-viewer:open'

const EMPTY_PHOTOS = []

const PhotoViewerBridge = () => {
  const [request, setRequest] = useState(null)

  useEffect(() => {
    const handler = event => setRequest(event.detail)
    document.addEventListener(OPEN_EVENT, handler)
    return () => document.removeEventListener(OPEN_EVENT, handler)
  }, [])

  const handleClose = useCallback(() => setRequest(null), [])

  return (
    <PhotoViewer
      isOpen={request !== null}
      photos={request?.photos || EMPTY_PHOTOS}
      startIndex={request?.index || 0}
      onClose={handleClose}
    />
  )
}

export default PhotoViewerBridge
